import { isValidCNPJ } from "cnpj-cpf-validator";

const validateCnpj = (value) => {
    return isValidCNPJ(value);
};

export default validateCnpj;